'use strict';

define('app/setup/componentLoaders',['knockout', 'componentLoaders/i18nComponentLoader'], function (ko, I18NComponentLoader) {

	var i18NLoader = new I18NComponentLoader(ko.components.defaultLoader);
	ko.components.loaders.unshift(i18NLoader);
});
